var share = function share(data) {
  return {
    content_type: 'produto',
    event: 'share',
    item_id: (data == null ? void 0 : data.variationId) || null,
    method: (data == null ? void 0 : data.iconName) || null
  };
};
export default share;